import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { OnboardingProvider } from "@/contexts/OnboardingContext";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { TopBar } from "./TopBar";
import { SkipLink } from "@/components/ui/skip-link";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { MaintenanceNotification } from "@/components/notifications/MaintenanceNotification";

const AppLayout = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/auth");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <OnboardingProvider>
      <SidebarProvider>
        <SkipLink href="#main-content" />
        <MaintenanceNotification />
        <div className="min-h-screen flex w-full">
          <AppSidebar />
          <div className="flex-1 flex flex-col">
            <TopBar user={user} />
            <main
              id="main-content"
              className="flex-1 p-6 bg-muted/30"
              role="main"
              aria-label="メインコンテンツ"
              tabIndex={-1}
            >
              <Outlet />
            </main>
          </div>
        </div>
      </SidebarProvider>
    </OnboardingProvider>
  );
};

export default AppLayout;
